module.exports = __webpack_public_path__ + "svg/chevron-right.595bafa3bfd0902b6be233e5156c9844.svg";